import * as React from "react"
import { Skeleton } from "@mui/material";

import { TitleWithPopover, AppTableSeeker } from "@components";
import { PRICING_ROUTES } from "@constants";
import { useShareUrl } from "@hooks";
import { endDate } from "@signals";
import { prevEndDate } from "@signals/filters";
import {changesColumn, currentPriceColumn, dateColumn, diffMyPriceColumn, listPriceColumn, myPriceColumn, prevPriceColumn, retailerColumn, skuColumn} from "./columns"
import { usePricingDiscountRoleConfig } from "../../../@hooks"
import PriceDiscountTopMarketChangesTableActions from "../TableActions"
import PricingDiscountTableTitleLink from "../../TableTitleLink"


export default function PriceTopMarketChangesPriceTable({data, isLoading, selectedCountry, countries, handleSelectedCountry}) {

	const { buildShareParams } = useShareUrl()
	const { isRetailerUser, isStandardUser } = usePricingDiscountRoleConfig()

	if (isLoading) return <Skeleton variant="rectangular" height={500} />

    return <AppTableSeeker
		title={
			<PricingDiscountTableTitleLink 
			title="Top 20 Price Changes" 
			tooltip="Go to Price Changes"
			url={`${PRICING_ROUTES.CHANGES_PATH}?sp=${buildShareParams({ currentSingleDate: endDate.value, prevSingleDate: prevEndDate.value })}&launch=true`} 
		/>}
		data={data}
		columns={[
			...retailerColumn(),
			...skuColumn(),
			prevPriceColumn(),
			currentPriceColumn(),
			...changesColumn(),
			...isRetailerUser ? [...myPriceColumn('myListPrice', 'My Min List Price')] : [],
			...isRetailerUser ? [...myPriceColumn('mainPrice', 'My Min Current Price')] : [],
			...isStandardUser ? [...myPriceColumn('rrsp', 'RRSP')] : [],
			...isRetailerUser ? [diffMyPriceColumn('Diff vs My Min Current Price', 'mainPrice')] : [],
			...isStandardUser ? [diffMyPriceColumn('Diff vs RRSP', 'rrsp')] : [],
		]}
		options={{
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			rowsPerPage: 5,
			rowsPerPageOptions: [5, 10],
			customToolbar: () => {
				return <PriceDiscountTopMarketChangesTableActions
					selectedCountry={selectedCountry}
					countries={countries}
					onClick={handleSelectedCountry}
				/>
			}
		}}
		textLabels= {{
			body: {
				noMatch: 'Mmmm, it seems like the prices haven’t moved much during the selected dates.'
			}
		}}
	/>
}